import { IIoxLog } from "../../services/ioxDataHandler";
import { IVehicleDrivingEvent } from "../../services/serverEvents";

export interface IIoxDataPayload {
    newLog: IIoxLog;
    activeDriverName?: string;
}

export interface IGpsDataPayload {
    speed: number;
    dateTime: string;
}

export interface ILastFiveSecondAvgGpsPayload {
    user: IUser | null;
    lastFiveSecondAvgGpsSpeed: number;
    checkingVehicleStopped: boolean;
    dateTime: string;
}

export interface IStateUpdate {
    isDriving?: boolean;
    source: string;
    loggingMessage: string;
}

export interface IDeviceMovement {
    pubSubPayload?: IVehicleDrivingEvent;
    gpsDataPayload?: IGpsDataPayload;
    lastFiveSecondAvgGpsPayload?: ILastFiveSecondAvgGpsPayload;
    ioxDataPayload?: IIoxDataPayload;
    stateUpdate?: IStateUpdate;
    lastPayloadUpdated?: IEventType;
}

export enum IEventType {
    pubSub = 1,
    ioxData = 4,
    stateUpdate = 5
}

export enum DeviceMovementActionTypes {
    SET_PUB_SUB_PAYLOAD = "SET_PUB_SUB_PAYLOAD",
    SET_IOX_DATA_PAYLOAD = "SET_IOX_DATA_PAYLOAD",
    SET_STATE_UPDATE = "SET_STATE_UPDATE",
    SET_LAST_PAYLOAD_UPDATED = "SET_LAST_PAYLOAD_UPDATED",
    CLEAR_STATE_UPDATE = "CLEAR_STATE_UPDATE"
}